module.exports = __webpack_public_path__ + "img/product_abraxane_pic.c545f5e5.png";